export const SESSION_TYPES = {
  online: {
    id: 'video',
    title: 'Online therapy',
    tag: 'video'
  },
  inPerson: {
    id: 'in_person',
    title: 'In-person',
    tag: 'in_person'
  }
} as const;
